import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import BackArrowIcon from "../../../components/Icons/BackArrowIcon";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import CommonTable from "../../../components/comman/CommonTable";
import DeleteIcon from "../../../components/Icons/DeleteIcon";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import ConfirmModal from "../../../components/comman/ConfirmModal";
import { toast } from "react-toastify";
import PlusIcon from "../../../components/Icons/PlusIcon";
import AddReadingModal from "./AddReading";
import AddDocumentModal from "./AddDocument";
import AddServiceModal from "./AddService";
import ChangeStatusModal from "./ChangeStatus";
import TransferMachineryModal from "./TransferMachinery";
import ViewIcon from "../../../components/Icons/ViewIcon";
import Logs from "../../Logs/Logs";
import moment from "moment";
import { DateRangePicker } from "rsuite";
import BgBlurLoader from "../../../components/Loaders/BgBlurLoader";
import EditIcon from "../../../components/Icons/EditIcon";
import "./MachineryDetails.css";

const getStatusLabel = (status) => {
    if (status === 1 || status === true || status === "1" || status === "Operational") return "Operational";
    if (status === 0 || status === false || status === "0" || status === "Inactive") return "Inactive";
    return status || "Operational";
};

/* ── Stat strip chip ── */
function StatChip({ label, value, isFirst }) {
    return (
        <div className={`md-stat-item${isFirst ? " md-stat-item--first" : ""}`}>
            <p className="md-stat-label">{label}</p>
            <p className="md-stat-value">
                {value || <span className="md-stat-empty">—</span>}
            </p>
        </div>
    );
}

/* ── Overview detail row ── */
function DetailRow({ label, value }) {
    return (
        <div className="md-detail-row">
            <span className="md-detail-label">{label}</span>
            <span className="md-detail-value">
                {value || <span className="md-detail-empty">—</span>}
            </span>
        </div>
    );
}

/* ── Section heading ── */
function SectionTitle({ title }) {
    return <p className="md-section-title">{title}</p>;
}

export default function MachineryDetails() {
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(false);
    const [dataLoading, setDataLoading] = useState(false);
    const [selectedId, setSelectedId] = useState("");
    const [refreshLogs, setRefreshLogs] = useState(false);
    const [machineryRequestData, setMachineryRequestData] = useState();
    const [activeTab, setActiveTab] = useState(location?.state?.initialTab || "overview");
    const [documents, setDocuments] = useState([]);
    const [docsLoading, setDocsLoading] = useState(false);
    const [services, setServices] = useState([]);
    const [servicesLoading, setServicesLoading] = useState(false);
    const [pageStates, setPageStates] = useState({
        currentPage: 1,
        pageSize: 10,
        count: 0,
        totalPages: 0,
        machineryReadingList: [],
        tableLoader: false,
        sortByDate: "",
    });
    const [modal, setModal] = useState({ addData: false, deleteData: false, documentModal: false, serviceModal: false, statusModal: false, transferModal: false });

    const toggleModal = (type) => {
        setModal((pre) => ({
            ...pre,
            ...(type === "delete"
                ? { deleteData: !pre.deleteData }
                : type === "document"
                ? { documentModal: !pre.documentModal }
                : type === "service"
                ? { serviceModal: !pre.serviceModal }
                : type === "status"
                ? { statusModal: !pre.statusModal }
                : type === "transfer"
                ? { transferModal: !pre.transferModal }
                : { addData: !pre.addData }),
        }));
    };

    useEffect(() => { GetMachineryRequestDetail(); }, []);
    useEffect(() => { GetMachinerReading(); }, [pageStates.currentPage, pageStates.sortByDate, pageStates.pageSize]);
    useEffect(() => { if (activeTab === "documents") GetDocuments(); }, [activeTab]);
    useEffect(() => { if (activeTab === "services") GetServices(); }, [activeTab]);

    const GetMachineryRequestDetail = () => {
        setDataLoading(true);
        callApi(apiUrl?.get_machinery_detail + `?machineryId=${id}`, { method: "GET" }).then((res) => {
            setDataLoading(false);
            if (res?.status === true) {
                setMachineryRequestData(res?.data);
                if (res?.data?.documents) {
                    setDocuments(res?.data?.documents);
                }
                if (res?.data?.machineryservices) {
                    setServices(res?.data?.machineryservices);
                }
            }
        });
    };

    const GetDocuments = () => {
        setDocsLoading(true);
        callApi(apiUrl.get_machinery_document + `?machineryId=${id}`, { method: "GET" }).then((res) => {
            setDocsLoading(false);
            if (res?.status === true) setDocuments(res?.data?.documents || res?.data || []);
        });
    };

    const GetServices = () => {
        setServicesLoading(true);
        callApi(apiUrl.get_machinery_service + `?machineryId=${id}`, { method: "GET" }).then((res) => {
            setServicesLoading(false);
            if (res?.status === true) setServices(res?.data?.services || res?.data || []);
        });
    };

    const GetMachinerReading = () => {
        const Url = apiUrl.get_machinery_reading + `?machineryId=${id}&` + MainFilterHandler(pageStates);
        setPageStates((pre) => ({ ...pre, tableLoader: !pre.tableLoader }));
        callApi(Url, { method: "GET" }).then((res) => {
            setPageStates((pre) => ({ ...pre, tableLoader: !pre.tableLoader }));
            if (res?.status === true) {
                const newData = res?.data?.machineryReading?.map((item) => ({
                    ...item,
                    readingDate: moment(item?.date).format("DD MMM YYYY"),
                }));
                setPageStates((pre) => ({
                    ...pre,
                    count: res?.data?.pageInfo?.total,
                    totalPages: res?.data?.pageInfo?.totalPages,
                    machineryReadingList: newData,
                }));
            }
        });
    };

    const TableHeading = [
        { value: "index", label: "SR NO." },
        { value: "readingDate", label: "Date" },
        { value: "reading", label: "Reading" },
        { value: "fuelConsumption", label: "Fuel Consumption" },
    ];

    const PageChangeHandler = (PageNo) => {
        if (PageNo > 0 && PageNo <= pageStates?.totalPages)
            setPageStates((prev) => ({ ...prev, currentPage: PageNo }));
    };
    const handleChangePageSize = (value) =>
        setPageStates((prev) => ({ ...prev, pageSize: value, currentPage: 1 }));

    const [deleteTarget, setDeleteTarget] = useState("reading");

    const ActionHandler = (data) => {
        setDeleteTarget("reading");
        setSelectedId(data?.id);
        toggleModal("delete");
    };

    const HandleDelete = () => {
        setIsLoading(true);
        let apiEndpoint = "";
        let callback = () => {};

        if (deleteTarget === "document") {
            apiEndpoint = apiUrl.delete_machinery_document + `?documentId=${selectedId}`;
            callback = GetDocuments;
        } else if (deleteTarget === "service") {
            apiEndpoint = apiUrl.delete_machinery_service + `?serviceId=${selectedId}`;
            callback = GetServices;
        } else {
            apiEndpoint = apiUrl.delete_machinery_reading + `?machineryReadingId=${selectedId}`;
            callback = GetMachinerReading;
        }

        callApi(apiEndpoint, { method: "GET" }).then((res) => {
            setIsLoading(false);
            if (res?.status === true) {
                toast.success(res?.message);
                toggleModal("delete");
                callback();
                setRefreshLogs(true);
            } else {
                toast.error(res?.message);
                toggleModal("delete");
            }
        });
    };

    const ActionData = [
        { label: "Delete", className: "btn btn-link", icon: <DeleteIcon />, title: "delete", clickHandler: ActionHandler },
    ];

    const dateChangeHandler = (Dates) => {
        if (Dates && Dates.length === 2) {
            const fmt = (d) => new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
            setPageStates((p) => ({ ...p, sortByDate: [fmt(Dates[0]), fmt(Dates[1])] }));
        } else {
            setPageStates((p) => ({ ...p, sortByDate: "" }));
        }
    };

    const handleReadingSuccess = () => {
        GetMachinerReading();
        setRefreshLogs(true);
    };

    const handleDocumentSuccess = () => {
        GetDocuments();
        setRefreshLogs(true);
    };

    const handleServiceSuccess = () => {
        GetServices();
        setRefreshLogs(true);
    };

    const handleStatusSuccess = () => {
        GetMachineryRequestDetail();
        setRefreshLogs(true);
    };

    const handleTransferSuccess = () => {
        GetMachineryRequestDetail();
        setRefreshLogs(true);
    };

    const d = machineryRequestData;
    const isActive = d?.status === 1 || d?.status === true;

    const tabs = [
        { key: "overview", label: "Overview" },
        { key: "readings", label: `Reading History${pageStates.count ? `  ${pageStates.count}` : ""}` },
        { key: "documents", label: `Documents${documents.length ? `  ${documents.length}` : ""}` },
        { key: "services", label: `Service History${services.length ? `  ${services.length}` : ""}` },
        { key: "logs", label: "Activity Logs" },
    ];

    const STATS = [
        { label: "Machine No.", value: d?.machineNumber },
        { label: "Hours / KM", value: d?.firstServiceAt ? `${d.firstServiceAt} ${d.readingType || ""}` : null },
        { label: "PO Number", value: d?.poNumber },
        { label: "PT Number", value: d?.ptNumber },
        { label: "Asset Value", value: d?.purchaseCost ? `₹${Number(d.purchaseCost).toLocaleString("en-IN")}` : null },
        { label: "Fuel Type", value: d?.fuelType },
        { label: "Purchase Date", value: d?.purchaseDate ? moment(d.purchaseDate).format("DD MMM YYYY") : null },
    ];

    return (
        <>
            {dataLoading && <BgBlurLoader />}
            <div className="content container-fluid md-page">

                {/* Back button */}
                <div className="mb-3">
                    <button className="md-back-btn" onClick={() => navigate(-1)}>
                        <BackArrowIcon /> Asset Register
                    </button>
                </div>

                {/* Main panel */}
                <div className="md-panel">

                    {/* Header */}
                    <div className="md-header">

                        {/* Title row */}
                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-3 mb-2">
                            <div>
                                <div className="d-flex align-items-center gap-3 flex-wrap">
                                    <h2 className="md-machine-name">{d?.name || "—"}</h2>
                                    <span className={`md-status-badge status-${getStatusLabel(d?.status).toLowerCase().replace(/\s+/g, "-")}`}>
                                        {getStatusLabel(d?.status)}
                                    </span>
                                </div>
                                <p className="md-subtitle">
                                    {[d?.assetNo, d?.model && `${d.model}${d.year ? ` (${d.year})` : ""}`, d?.type, d?.site?.name]
                                        .filter(Boolean)
                                        .join(" · ")}
                                </p>
                            </div>
                            <div className="d-flex gap-2">
                                <button className="md-action-btn" onClick={() => toggleModal()}>
                                    <PlusIcon /> Log Reading
                                </button>
                                <button className="md-action-btn" onClick={() => toggleModal("status")}>
                                    Change Status
                                </button>
                                <button className="md-action-btn" onClick={() => toggleModal("transfer")}>
                                    Transfer
                                </button>
                                <button
                                    className="md-action-btn"
                                    onClick={() => navigate(RoutesLink.add_machinery, { state: { EditData: d } })}
                                >
                                    <EditIcon /> Edit
                                </button>
                            </div>
                        </div>

                        {/* Stats strip */}
                        <div className="md-stats-strip">
                            {STATS.map((s, i) => (
                                <StatChip key={s.label} label={s.label} value={s.value} isFirst={i === 0} />
                            ))}
                        </div>

                        {/* Tab nav */}
                        <div className="md-tabs">
                            {tabs.map((tab) => (
                                <button
                                    key={tab.key}
                                    className={`md-tab-btn${activeTab === tab.key ? " active" : ""}`}
                                    onClick={() => setActiveTab(tab.key)}
                                >
                                    {tab.label}
                                </button>
                            ))}
                        </div>
                    </div>

                    {/* Tab content */}
                    <div className="md-tab-content">

                        {/* ── OVERVIEW ── */}
                        {activeTab === "overview" && (
                            <div className="row">
                                <div className="col-12 col-lg-6">
                                    <SectionTitle title="Basic Information" />
                                    <DetailRow label="Machine Name" value={d?.name} />
                                    <DetailRow label="Type" value={d?.type} />
                                    <DetailRow label="Asset Number" value={d?.assetNo} />
                                    <DetailRow label="Machine Number" value={d?.machineNumber} />
                                    <DetailRow label="Fuel Type" value={d?.fuelType} />
                                    <DetailRow label="Reading Type" value={d?.readingType} />
                                    <DetailRow label="Site" value={d?.site?.name} />
                                    <DetailRow
                                        label="First Service At"
                                        value={d?.firstServiceAt ? `${d.firstServiceAt} ${d.readingType || ""}` : null}
                                    />
                                    <SectionTitle title="Technical Specifications" />
                                    <DetailRow label="Make" value={d?.make} />
                                    <DetailRow label="Model" value={d?.model} />
                                    <DetailRow label="Year" value={d?.year} />
                                    <DetailRow label="Chassis Number" value={d?.chesisNumber} />
                                    <DetailRow label="Engine Number" value={d?.engineNumber} />
                                </div>
                                <div className="col-12 col-lg-6">
                                    <SectionTitle title="Purchase Details" />
                                    <DetailRow
                                        label="Purchase Cost"
                                        value={d?.purchaseCost ? `₹${Number(d.purchaseCost).toLocaleString("en-IN")}` : null}
                                    />
                                    <DetailRow
                                        label="Purchase Date"
                                        value={d?.purchaseDate ? moment(d.purchaseDate).format("DD MMM YYYY") : null}
                                    />
                                    <DetailRow label="PO Number" value={d?.poNumber} />
                                    <DetailRow label="PT Number" value={d?.ptNumber} />
                                    <DetailRow label="Vendor" value={d?.Vendor?.firmName || d?.vendor?.firmName} />
                                    <DetailRow label="Purchased By" value={d?.purchasedBy?.name || d?.user?.name} />
                                </div>
                            </div>
                        )}

                        {/* ── READING HISTORY ── */}
                        {activeTab === "readings" && (
                            <>
                                <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-4">
                                    <div>
                                        <h5 className="md-tab-title">Reading History</h5>
                                        <p className="md-tab-subtitle">Fuel consumption and meter readings over time</p>
                                    </div>
                                    <div className="d-flex align-items-center gap-2 flex-wrap">
                                        <DateRangePicker
                                            size="md"
                                            format="dd/MM/yyyy"
                                            placeholder="Filter by date range"
                                            placement="bottomEnd"
                                            onChange={dateChangeHandler}
                                        />
                                        <button className="md-primary-btn" onClick={() => toggleModal()}>
                                            <PlusIcon /> Add Reading
                                        </button>
                                    </div>
                                </div>
                                <CommonTable
                                    TableHeading={TableHeading}
                                    TableData={pageStates?.machineryReadingList}
                                    ActionData={ActionData}
                                    currentPage={pageStates?.currentPage}
                                    PageChangeHandler={PageChangeHandler}
                                    isLoading={pageStates?.tableLoader}
                                    totalPages={pageStates?.totalPages}
                                    count={pageStates?.count}
                                    handleChangePageSize={handleChangePageSize}
                                    pageSize={pageStates.pageSize}
                                />
                            </>
                        )}

                        {/* ── DOCUMENTS ── */}
                        {activeTab === "documents" && (
                            <>
                                <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-4">
                                    <div>
                                        <h5 className="md-tab-title">Documents</h5>
                                        <p className="md-tab-subtitle">Compliance records and expiry tracking</p>
                                    </div>
                                    <button className="md-primary-btn" onClick={() => toggleModal("document")}>
                                        <PlusIcon /> Add document
                                    </button>
                                </div>

                                {docsLoading ? (
                                    <div className="text-center py-5 text-muted">Loading documents…</div>
                                ) : documents.length === 0 ? (
                                    <div className="md-docs-empty">
                                        <div className="md-docs-empty-icon">📄</div>
                                        <p className="md-docs-empty-title">No documents yet</p>
                                        <p className="md-docs-empty-sub">
                                            Add insurance, fitness certificates, and other compliance records
                                        </p>
                                    </div>
                                ) : (
                                    <div className="md-docs-wrapper">
                                        <table className="md-docs-table">
                                            <thead>
                                                <tr>
                                                    {["Type", "Number", "Issued By", "Issue Date", "Expiry", "Status", ""].map((h) => (
                                                        <th key={h} className="md-docs-th">{h}</th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {documents.map((doc) => {
                                                    const expiry = doc.expiryDate ? moment(doc.expiryDate) : null;
                                                    const daysLeft = expiry ? expiry.diff(moment(), "days") : null;
                                                    const isExpired = daysLeft !== null && daysLeft < 0;
                                                    const isExpiringSoon = daysLeft !== null && daysLeft >= 0 && daysLeft <= 30;
                                                    const statusLabel = isExpired ? "Expired" : isExpiringSoon ? `Expires in ${daysLeft}d` : "Valid";
                                                    const statusCls = isExpired ? "expired" : isExpiringSoon ? "expiring" : "valid";
                                                    return (
                                                        <tr key={doc.id} className="md-docs-tr">
                                                            <td className="md-docs-td md-docs-td-name">{doc.documentType || doc.type || "—"}</td>
                                                            <td className="md-docs-td md-docs-td-number">{doc.documentNumber || doc.number || "—"}</td>
                                                            <td className="md-docs-td">{doc.issuedBy || "—"}</td>
                                                            <td className="md-docs-td">{doc.issueDate ? moment(doc.issueDate).format("DD MMM YYYY") : "—"}</td>
                                                            <td className={`md-docs-td${isExpired || isExpiringSoon ? " fw-bold" : ""}`}>
                                                                {expiry ? expiry.format("DD MMM YYYY") : "—"}
                                                            </td>
                                                            <td className="md-docs-td">
                                                                <span className={`md-doc-status ${statusCls}`}>{statusLabel}</span>
                                                            </td>
                                                            <td className="md-docs-td">
                                                                <div className="d-flex align-items-center gap-2">
                                                                    {doc.url && (
                                                                        <a
                                                                            href={doc.url}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            className="md-view-btn"
                                                                            title="View Document"
                                                                        >
                                                                            <ViewIcon />
                                                                        </a>
                                                                    )}
                                                                    <button
                                                                        className="md-delete-btn"
                                                                        onClick={() => {
                                                                            setDeleteTarget("document");
                                                                            setSelectedId(doc.id);
                                                                            toggleModal("delete");
                                                                        }}
                                                                    >
                                                                        <DeleteIcon />
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </>
                        )}

                        {/* ── SERVICE HISTORY ── */}
                        {activeTab === "services" && (
                            <>
                                <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-4">
                                    <div>
                                        <h5 className="md-tab-title">Service History</h5>
                                        <p className="md-tab-subtitle">Logs of maintenance, service, and repairs</p>
                                    </div>
                                    <button className="md-primary-btn" onClick={() => toggleModal("service")}>
                                        <PlusIcon /> Log service
                                    </button>
                                </div>

                                {servicesLoading ? (
                                    <div className="text-center py-5 text-muted">Loading services…</div>
                                ) : services.length === 0 ? (
                                    <div className="md-docs-empty">
                                        <div className="md-docs-empty-icon">🛠️</div>
                                        <p className="md-docs-empty-title">No service records yet</p>
                                        <p className="md-docs-empty-sub">
                                            Log oil changes, filter replacements, repairs, and other maintenance activities
                                        </p>
                                    </div>
                                ) : (
                                    <div className="md-docs-wrapper">
                                        <table className="md-docs-table">
                                            <thead>
                                                <tr>
                                                    {["Date", "Reading", "Work Done / Description", "Vendor / Technician", "Cost", "PO / PT", ""].map((h) => (
                                                        <th key={h} className="md-docs-th">{h}</th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {services.map((service) => {
                                                    const vendorName = service.Vendor?.firmName || service.vendor?.firmName || service.technicianName || "—";
                                                    const showTechnician = service.technicianName && (service.Vendor?.firmName || service.vendor?.firmName);
                                                    return (
                                                        <tr key={service.id} className="md-docs-tr">
                                                            <td className="md-docs-td">{service.date ? moment(service.date).format("DD MMM YYYY") : "—"}</td>
                                                            <td className="md-docs-td fw-bold">{service.atHours ? `${service.atHours} ${d?.readingType || ""}` : "—"}</td>
                                                            <td className="md-docs-td" style={{ maxWidth: "300px", whiteSpace: "normal", wordBreak: "break-word" }}>
                                                                {service.workDone || "—"}
                                                            </td>
                                                            <td className="md-docs-td">
                                                                <div className="fw-bold">{vendorName}</div>
                                                                {showTechnician && <div style={{ fontSize: "0.85rem", color: "#64748b" }}>Tech: {service.technicianName}</div>}
                                                            </td>
                                                            <td className="md-docs-td fw-bold text-success">
                                                                {service.cost ? `₹${Number(service.cost).toLocaleString("en-IN")}` : "₹0"}
                                                            </td>
                                                            <td className="md-docs-td">
                                                                {service.poNumber && <div>PO: <span className="fw-bold text-primary">{service.poNumber}</span></div>}
                                                                {service.ptNumber && <div>PT: <span className="fw-bold text-info">{service.ptNumber}</span></div>}
                                                                {!service.poNumber && !service.ptNumber && "—"}
                                                            </td>
                                                            <td className="md-docs-td">
                                                                <button
                                                                    className="md-delete-btn"
                                                                    onClick={() => {
                                                                        setDeleteTarget("service");
                                                                        setSelectedId(service.id);
                                                                        toggleModal("delete");
                                                                    }}
                                                                >
                                                                    <DeleteIcon />
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </>
                        )}
                        {activeTab === "logs" && (
                            <Logs
                                type="machinery"
                                id={id}
                                refreshLogs={refreshLogs}
                                setRefreshLogs={setRefreshLogs}
                                name={d?.name}
                                showBackButton={false}
                            />
                        )}
                    </div>
                </div>
            </div>

            <ConfirmModal
                modal={modal.deleteData}
                toggle={() => toggleModal("delete")}
                submitHandler={HandleDelete}
                isLoading={isLoading}
            />
            <AddReadingModal
                modal={modal.addData}
                toggle={toggleModal}
                GetExpenseHeadList={handleReadingSuccess}
                modalData={id}
            />
            <AddDocumentModal
                modal={modal.documentModal}
                toggle={toggleModal}
                machineryId={id}
                machineryName={d?.name}
                assetNo={d?.assetNo}
                onSuccess={handleDocumentSuccess}
            />
            <AddServiceModal
                modal={modal.serviceModal}
                toggle={toggleModal}
                machineryId={id}
                machineryName={d?.name}
                assetNo={d?.assetNo}
                onSuccess={handleServiceSuccess}
            />
            <ChangeStatusModal
                modal={modal.statusModal}
                toggle={toggleModal}
                machineryId={id}
                machineryName={d?.name}
                currentStatus={getStatusLabel(d?.status)}
                onSuccess={handleStatusSuccess}
            />
            <TransferMachineryModal
                modal={modal.transferModal}
                toggle={toggleModal}
                machineryId={id}
                machineryName={d?.name}
                currentSiteName={d?.site?.name}
                currentSiteId={d?.siteId}
                onSuccess={handleTransferSuccess}
            />
        </>
    );
}